const getTimezone = (): number => {
  const date = new Date();
  return date.getTimezoneOffset();
};

export const DateTimeHelper = {
  getTimezone,
};
